export default "__VITE_ASSET__BqQqW28f__"